import { debounce } from '../lib/debounce'
import { useLatest } from '@/shared/hooks/useLatest.js'
import { useMemo } from 'react'

export function useDebounce(cb, ms) {
    const latestCb = useLatest(cb)

    return useMemo(
        () =>
            debounce((...args) => {
                latestCb.current(...args)
            }, ms),
        [ms, latestCb]
    )
}
